import { combineReducers } from 'redux';
import bank from './bankReducer';
import catalog from './catalogReducer';
import category from './categoryReducer';
import common from './commonReducer';
import config from './configReducer';
import deal from './dealReducer';
import deposit from './depositReducer';
import location from './locationReducer';
import notification from './notification';
import profile from './profileReducer';
import referral from './referralReducer';
import saleOrder from './saleOrderReducer';
import tracking from './trackingReducer';
import user from './userReducer';
import vnTracking from './vnTracking';
import website from './websiteReducer';

export default combineReducers({
  bank,
  catalog,
  category,
  common,
  config,
  deal,
  deposit,
  location,
  notification,
  profile,
  referral,
  saleOrder,
  tracking,
  user,
  vnTracking,
  website
});
